import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';
import classnames from 'classnames';

const styles = theme => ({
    root: {
    },
    heading: {
        padding: theme.spacing(1),
    },
    main: {
        padding: theme.spacing(1),
        border: '2px solid transparent',
    },
    background: {
        background: theme.colors.blue4,
        border: theme.borders.blue,
    },
    borderNormal: {
        border: theme.borders.green,
    },
    borderDashed: {
        border: theme.borders.dashed,
    },
});

class ContentBox extends React.Component {
    render() {
        const {
            classes, className, heading, children, variant,
        } = this.props;

        return (
            <div className={classnames(classes.root, className)}>
                <Typography variant="subtitle2" className={classes.heading}>
                    { heading }
                </Typography>
                <div className={classnames(classes.main, {
                    [classes.background]: variant === 'filled',
                    [classes.borderNormal]: variant === 'bordered',
                    [classes.borderDashed]: variant === 'dashed',
                })}
                >
                    {children}
                </div>
            </div>
        );
    }
}

ContentBox.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    heading: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'filled', 'bordered', 'dashed']),
};

ContentBox.defaultProps = {
    children: null,
    className: null,
    heading: null,
    variant: 'default',
};

export default withStyles(styles)(ContentBox);
